var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.22842 12.7451C2.52015 11.8249 2.16602 11.3649 2.16602 9.9987C2.16602 8.63253 2.52015 8.17247 3.22842 7.25231C4.64265 5.415 7.01444 3.33203 10.4993 3.33203C13.9843 3.33203 16.356 5.415 17.7703 7.25231C18.4785 8.17247 18.8327 8.63253 18.8327 9.9987C18.8327 11.3649 18.4785 11.8249 17.7703 12.7451C16.356 14.5824 13.9843 16.6654 10.4993 16.6654C7.01444 16.6654 4.64265 14.5824 3.22842 12.7451Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 11.3807 11.8807 12.5 10.5 12.5C9.11925 12.5 8 11.3807 8 10C8 8.61925 9.11925 7.5 10.5 7.5C11.8807 7.5 13 8.61925 13 10Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.aa022c6aa8d35f25911f85a56f3e33d5.svg";
export { ForwardRef as ReactComponent };